import { deleteApi, get, post } from "../GenericServices";

const ProjectGanttPlann = {
  getDataGantt: (id) => {
    return get(`project/${id}/project-gantt-plan`);
  },
  addTask: (id, data) => {
    return post(`project/${id}/project-gantt-plan`, data);
  },
  changePosition: (projectId, id, queryString) => {
    return post(`project/${projectId}/project-gantt-plan/${id}/move?${queryString}`);
  },
  deletetask: (id, taskId) => {
    return deleteApi(`project/${id}/project-gantt-plan/${taskId}`);
  },
  getDataGanttTable: (id) => {
    return get(`project/${id}/project-gantt-plan/project-task-table`);
  },
};

export default ProjectGanttPlann;
